import React from 'react';

type PaginatorProps = {
    currentPage: number;
    rowsPerPage: number;
    numberOfPages: number;
    numberOfRecords: number;
    onChange: (currentPage: number, rowsPerPage: number) => void;
    showTotalRecordCount?: boolean;
};

export const Paginator: React.FunctionComponent<PaginatorProps> = ({
                                                                       currentPage,
                                                                       rowsPerPage,
                                                                       numberOfPages,
                                                                       numberOfRecords,
                                                                       showTotalRecordCount = false,
                                                                       onChange
                                                                   }: PaginatorProps) => {

    return (
        <nav id="paginator">
            <ul className="pagination justify-content-end">
                <li className="page-item">
                    <button className="page-link"
                            onClick={() => {
                                onChange && onChange(1, rowsPerPage);
                            }}
                            disabled={currentPage === 1}
                    >
                        <i className="fas fa-chevron-left"/>
                        <i className="fas fa-chevron-left"/>
                    </button>
                </li>
                <li className="page-item">
                    <button className="page-link"
                            onClick={() => {
                                onChange && onChange(currentPage - 1, rowsPerPage);
                            }}
                            disabled={currentPage === 1}
                    >
                        <i className="fas fa-chevron-left"/>
                    </button>
                </li>
                <li className="page-item"><a href="#" className="page-link">Page {currentPage} of {numberOfPages}</a>
                </li>
                <li className="page-item">
                    <button className="page-link"
                            onClick={() => {
                                onChange && onChange(currentPage + 1, rowsPerPage);
                            }}
                            disabled={currentPage === numberOfPages}
                    >
                        <i className="fas fa-chevron-right"/>
                    </button>
                </li>
                <li className="page-item">
                    <button className="page-link"
                            onClick={() => {
                                onChange && onChange(numberOfPages, rowsPerPage);
                            }}
                            disabled={currentPage === numberOfPages}
                    >
                        <i className="fas fa-chevron-right"/>
                        <i className="fas fa-chevron-right"/>
                    </button>
                </li>
            </ul>
            {showTotalRecordCount &&
                <div>
                    Total Records: <strong>{numberOfRecords}</strong>
                </div>
            }
        </nav>
    );
};
